import { CounterpartyType } from '@/constants/CounterpartyType';
import PortalDictionaryDTO from '@/dto/common/PortalDictionaryDTO';
import { Period } from '@/constants/DateTimeConstants';
import { TaxEventStatus } from '@/constants/TaxEventStatus';
import {BalanceEffect, PaymentStatus, TransactionType} from '@/constants/PaymentConstants';
import { Risk } from '@/constants/Risk';
import FileMetaDTO from "@/dto/files/FileMetaDTO";

export enum TaxEventReconciliationStatus {
    NOT_VERIFIED = 'NOT_VERIFIED',
    MATCHED = 'MATCHED',
    DIFFERENCE_FOUND = 'DIFFERENCE_FOUND',
    RESOLVED = 'RESOLVED'
}

export interface TaxEventReconciliationRecordDTO {
    id: number;
    agencyBalanceCents: number;
    internalBalanceCents: number;
    differenceCents: number;
    verificationDate: string;
    reconciliationStatus: TaxEventReconciliationStatus;
    comment: string | null;
    document: FileMetaDTO | null;
}

export interface TaxEventCommentDTO {
    id: number;
    comment: string;
    leftByName: string;
    createdAt: string; // Instant mapped to ISO string
}

export interface TaxEventLedgerRecordDTO {
    id: number;
    date: string;
    order: number;
    amountCents: number;
    balanceEffect: BalanceEffect;
    transactionType: TransactionType;
    balanceSnapshot: number;
}

export default interface TaxEventDTO {
    id: number;
    year: number;
    period: Period;
    eventDate: string; // LocalDate mapped to ISO string
    dueDate: string;
    paidOn: string | null;
    amountCents: number;
    status: TaxEventStatus;
    obligation: string | null;
    paymentStatus: PaymentStatus;
    risk: Risk;
    nextAction: string | null;
    assigneeId: number | null;
    assigneeName: string | null;
    taxType: PortalDictionaryDTO;
    customerId: number;
    customerType: CounterpartyType;
    customerName: string;
    customerEmail: string | null;
    comments: TaxEventCommentDTO[];
    ledger: TaxEventLedgerRecordDTO[];
    reconciliationRecords: TaxEventReconciliationRecordDTO[];
    createdByName: string;
    lastModifiedByName: string | null;
    createdAt: string;
    updatedAt: string | null;
    liabilityCents: number;
    paidCents: number;
    balanceDue: number;
    hasPayments: boolean;
}
